// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"71e672d5","845":"35e601fc"}[chunkId] + ".chunk.js";
};